var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-settings-info-view"},[_c('a-card',{attrs:{"bordered":false}},[_c('a-row',[_c('a-col',{attrs:{"span":8}},[_c('a-button',{on:{"click":_vm.toShow}},[_vm._v("CA 证书申请资料")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }